<script>
  import { onMount } from 'svelte';
  import { createVideo } from '../lib/youtube-vimeo-validator.js';
  import settings from '../config';
  import { TS } from '../config/translation-keys.js';
  import { t9n } from '../lib/translate.js';
  import APIClient from '../state-charts/api-client';
  import UnauthenticatedLayout from '../app-shell/guest-app/Layout.svelte';
  import ShareCV from './ShareCV.svelte';

  export let route_name;
  export let worker_id;

  let print_label = t9n(TS.CV_PRINT_LABEL);
  let about_title = t9n(TS.CV_ABOUT_ME);
  let education_title = t9n(TS.CV_EDUCATION_AND_CERTIFICATES);
  let educations_completed_text = t9n(TS.ORDER_COMPLETED_TXT);
  let languages_title = t9n(TS.CV_LANGUAGES);
  let experiences_title = t9n(TS.CV_MY_EXPERIENCES);
  let current_experience_text = t9n(TS.CV_CURRENT);
  let work_fields_title = t9n(TS.CV_WORKED_FIELDS);
  let worked_amount_text = t9n(TS.CV_WORKED_TIMES);
  let wp_tasks_title = t9n(TS.CV_LABEL_COMPLETED_GIGS);
  let no_tasks_message = t9n(TS.CV_NO_COMPLETED_TASKS_YET);

  let profile_image;
  let cv;
  let worker;
  let educations;
  let experiences;
  let languages;
  let categories;
  let feedbacks;
  let video;
  let share_dialog;
  let experience_videos = [];
  let merchant_color;

  const print_cv = () => {
    let pic_style;
    document.querySelector('.print-cv').disabled = true
    document.querySelector(".loading").style.display = "block";
    if (document.getElementById('#share-dialog')) document.getElementById('#share-dialog').remove();
    if (document.getElementById("#pic_style")) pic_style = document.getElementById("#pic_style").textContent;
    printJS({
      printable: 'the_cv',
      type: 'html',
      targetStyles: '[*]',
      scanStyles: false,
      style: pic_style,
      css: [
        '/css/cv/bootstrap.min.css',
        '/css/cv/font-awesome.min.css',
        '/css/cv/workerCV.css',
        '/css/cv/workerCV_print.css',
      ],
      onPrintDialogClose: function() {
        document.querySelector('.print-cv').disabled = false
        document.querySelector(".loading").style.display = "hide";
      },
    });
    setTimeout(function() {
      document.querySelector('.print-cv').disabled = false
      document.querySelector('.loading').style.display = "none";
    }, 1000);
  };

  const insert_profile_image = () => {
    profile_image = settings.api_host + worker.image_url;
  };

  const format_experience_date = experience => {
    let date = experience.start_month + '/' + experience.start_year + ' - ';
    if (experience.is_current) {
      date = date + current_experience_text;
    } else {
      date = date + experience.end_month + '/' + experience.end_year;
    }
    return date;
  };

  const format_rating_style = () => {
    let rating = (worker.rating + 5) * 10;
    return `${'width: {0}%;'.format(rating)}`;
  };

  const init_about_video = async () => {
    let wait = setInterval(() => {
      let video_el = document.getElementById('video_description');
      if (video_el) {
        video_el.append(video);
        clearInterval(wait);
      }
    }, 100);
  };

  const open_share_dialog = () => {
    let target = document.querySelector('.share-dialog');
    target.innerHTML = '';
    share_dialog = new ShareCV({
      target: target,
      props: { worker_id: worker_id, publicCV: true },
    });
    share_dialog.open();
  };

  const init_experiences_videos = async () => {
    if (!!experience_videos) {
      let wait = setInterval(() => {
        for (let i = 0; i < experience_videos.length; i++) {
          if (experience_videos[i] !== 'NOVIDEO') {
            let video_el = document.getElementById('experience_video_' + i);
            if (video_el) {
              video_el.append(experience_videos[i]);
            }
          }
        }
        clearInterval(wait);
      }, 100);
    }
  };

  const init_exprience_descriptions = () => {
    if (document.querySelector('.experience_description')) {
      let descriptions = document.querySelectorAll('.experience_description')
     // if (descriptions.length > 0) descriptions.linkify();
    }
  };

  const init_print = () => {
    document.querySelector(".print-cv").style.display = "block";
    document.querySelector(".loading").style.display = "hide";
    document.querySelector(".print-cv").onclick = function() {print_cv()};
  };

  const sort_experiences = () => {
    experiences.sort((a, b) => {
      let keyA = new Date(a.start_year, a.start_month);
      let keyB = new Date(b.start_year, b.start_month);
      if (keyA < keyB) return 1;
      if (keyA > keyB) return -1;
      return 0;
    });
    experiences.sort(function(a,b) {
      if (!a['is_current'] && b['is_current'])
        return 1;
      if (a['is_current'] && !b['is_current'])
        return -1;
      return a['is_current'] - b['is_current']
    });
  };

  const sort_educations = () => {
    educations.sort((a, b) => {
      let keyA = new Date(a.completed_year, a.completed_month);
      let keyB = new Date(b.completed_year, b.completed_month);
      if (keyA < keyB) return 1;
      if (keyA > keyB) return -1;
      return 0;
    });
    educations.sort(function(a,b) {
      if (!a['completed_is_current'] && b['completed_is_current'])
        return 1;
      if (a['completed_is_current'] && !b['completed_is_current'])
        return -1;
      return a['completed_is_current'] - b['completed_is_current']
    });
  };

  const setForegroundColor = (rgb) => {
    let sum = Math.round(
      (parseInt(rgb[0]) * 299 +
        parseInt(rgb[1]) * 587 +
        parseInt(rgb[2]) * 114) /
      1000,
    );
    return sum > 128 ? 'grey' : 'white';
  }

  function hexToRGBarr(h) {
    let r = 0,
      g = 0,
      b = 0;

    // 3 digits
    if (h.length == 4) {
      r = '0x' + h[1] + h[1];
      g = '0x' + h[2] + h[2];
      b = '0x' + h[3] + h[3];

      // 6 digits
    } else if (h.length == 7) {
      r = '0x' + h[1] + h[2];
      g = '0x' + h[3] + h[4];
      b = '0x' + h[5] + h[6];
    }

    return [r, g, b];
  }

  const set_merchant_colors = (cv_data) => {
      document
        .querySelector(':root')
        .style.setProperty(
        '--primary-bg-color',
        cv_data.cv_colors.custom_background_color,
      );
    document
      .querySelector(':root')
      .style.setProperty(
      '--primary-color',
      cv_data.cv_colors.custom_font_color,
    );

    //console.log(cv_data.cv_colors.merchant_cv_color)
  }

  const init_cv = async () => {
    document.querySelector(".loading").classList.remove('hidden')

    const urlParams = new URLSearchParams(window.location.search);
    merchant_color = urlParams.get('merchant_uuid');
    //console.log("0", merchant_color)
    let cv_data;

    cv_data = await APIClient.get_worker_cv(worker_id);
    if(merchant_color){
      let result = await APIClient.get_merchant_style(merchant_color);

      if(!!result.merchant_cv_color){
        cv_data.cv_colors.custom_background_color = result.merchant_cv_color;
        let rgb = hexToRGBarr(cv_data.cv_colors.custom_background_color);
        cv_data.cv_colors.custom_font_color = setForegroundColor(rgb);
        set_merchant_colors(cv_data)
      }

    } else{
      set_merchant_colors(cv_data)
    }

    let per_page = 100;
    let current_page = 1;

    worker = cv_data.worker;
    educations = worker.educations;
    experiences = worker.experiences;
    sort_experiences();
    sort_educations();
    languages = worker.languages;
    categories = cv_data.categories;
    feedbacks = cv_data.feedbacks;
    // feedbacks = cv_gigs.orders;
    // number_of_pages = cv_gigs.results_info.number_of_pages;

    if (worker && !!worker.video_link) {
      video = createVideo(worker.video_link);
    }
    if (experiences) {
      for (let experience of experiences) {
        if (!!experience.video_link) {
          experience_videos.push(
            createVideo(experience.video_link, '80%', '80%')
          );
        } else {
          experience_videos.push('NOVIDEO');
        }
      }
    }

    insert_profile_image();
    await init_about_video();
    await init_experiences_videos();
    init_exprience_descriptions();
    init_print();

    document.querySelector(".loading").classList.add('hidden')
  };

  onMount(async () => await init_cv());
</script>

<svelte:head>
  <link rel="stylesheet" href="/css/cv/print.min.css" />
  <link rel="stylesheet" href="/css/cv/workerCV.css" />
  <link rel="stylesheet" href="/css/cv/style-responsive.css" />
  <link rel="stylesheet" href="/css/cv/wp.css" />
  <link rel="stylesheet" href="/css/cv/font-awesome.min.css" />

  <link
    href="https://fonts.googleapis.com/css?family=Open+Sans:400,300,300italic,400italic,600,600italic,700,700italic,800,800italic);"
    rel="stylesheet"
    type="text/css" />

  <script src="/js/cv/bootstrap.min.js" defer>

  </script>
  <script src="/js/cv/print.min.js" type="text/javascript" defer>

  </script>
</svelte:head>

<UnauthenticatedLayout>
  <div class="cv-container" slot="content">
    <div class="cv-content container" id="the_cv">
      <div class="row">
        <div class="share-dialog" />
        <div class="cv-left left col-sm-5">
          <button class="print-cv no_print">{print_label}</button>
          <div class="profile-image-pos">
            <svg width="200" height="215" viewBox="0 0 200 215">
              <defs>
                <clipPath id="shape">
                  <path
                    transform="rotate(90, 100, 109)"
                    d="m-3.5,113.26279q-2.5,-4.33012
                    0,-8.66025l47.5,-82.27241q2.5,-4.33013 7.5,-4.33013l95,0q5,0
                    7.5,4.33013l47.5,82.27241q2.5,4.33013
                    0,8.66025l-47.5,82.27242q-2.5,4.33012
                    -7.5,4.33012l-95,0q-5,0 -7.5,-4.33012l-47.5,-82.27242z" />
                </clipPath>
              </defs>
              <image
                preserveAspectRatio="xMidYMid slice"
                width="100%"
                height="100%"
                clip-path="url(#shape)"
                href={profile_image} />
            </svg>
          </div>

          <div class="worker_contacts">
            <div
              class="inner"
              title={worker ? `${worker.first_name} ${worker.last_name}` : "user's name"}>
              <span
                style="font-weight: 600; font-size: 20px;"
                class="last_name">
                {worker ? worker.first_name : ''}
                {worker ? worker.last_name : ''}
              </span>
            </div>
            <span class="loading no_print hidden">
              <i class="fa fa-spin fa-spinner" />
            </span>
            <p style="margin-top: 3px" class="worker_email">
              {worker ? worker.email : ''}
            </p>
            <p style="margin-top: -14px" class="worker_phone">
              {worker ? `${worker.phone.code} ${worker.phone.number}` : ''}
            </p>
          </div>

          {#if worker && (worker.short_description_worker || worker.video_link)}
            <div class="left-section about">
              <h4 class="section-title">{about_title}</h4>
              {#if worker.short_description_worker}
                <p class="section-content about_me" style='white-space: pre-line;'>
                  {worker.short_description_worker}
                </p>
              {/if}
              {#if !!video}
                <div class="videoWrapper no_print" id="video_description" />
              {/if}
            </div>
          {/if}

          {#if !!educations && educations.length > 0}
            <div class="left-section educations">
              <h4 class="section-title">{education_title}</h4>
              <div style="margin-top:15px;">
                {#each educations as education}
                  <div style="margin-top:20px" class="education">
                    <div style="float:left;text-align: center;width:60px;">
                      <i
                        class="education_icon fa"
                        class:fa-graduation-cap={education.education_type === 'worker_education_type_education'}
                        class:fa-certificate={education.education_type !== 'worker_education_type_education'}
                        style="font-size:26px;" />
                    </div>
                    <div style="padding-left:60px;">
                      <div>
                        <b class="education_title">{education.title}</b>
                      </div>
                      <div
                        style="font-size:14px;font-weight: 300"
                        class="education_where">
                        {education.where}
                      </div>
                      {#if !education.completed_is_current}
                        <div
                          style="font-size:14px;font-weight: 300"
                          class="education_conclusion">
                          {`${educations_completed_text}: ${education.completed_month}/${education.completed_year}`}
                        </div>
                      {/if}
                    </div>
                  </div>
                {/each}
              </div>
            </div>
          {/if}

          {#if !!languages}
            <div class="left-section languages">
              <h4 class="section-title">{languages_title}</h4>
              <div style="text-align: center">
                {#each languages as language}
                  <div class="language">
                    <span class="language_name" title={language.level_name}>
                      {t9n(language.language_name)}
                    </span>
                    <img
                      class="language-level"
                      alt={t9n(language.language_name)}
                      src={`/assets/level/lvl${language.level}.png`} />
                  </div>
                {/each}
              </div>
            </div>
          {/if}
        </div>

        <div class="cv-right col-sm-7 right">
          {#if !!experiences}
            <div class="right-section experiences">
              <h4 class="section-title" style="position: relative">
                {experiences_title}
                <button
                  on:click={() => open_share_dialog()}
                  class="btn-share mdc-button mdc-button--unelevated">
                  <span class="mdc-button__ripple" />
                  {t9n(TS.CV_SHARE)}
                </button>

              </h4>

              {#each experiences as experience, i}
                <div class="experience">
                  <i
                    class="experience_icon fa"
                    class:fa-suitcase={experience.experience_type === 'worker_experience_type_job'}
                    class:fa-folder={experience.experience_type !== 'worker_experience_type_job'} />

                  <div>
                    <span class="experience_title">{experience.position}</span>
                    -
                    <span class="experience_where">{experience.where}</span>
                    <div class="experience_date">
                      {format_experience_date(experience)}
                    </div>
                    {#if experience.description}
                      <div class="experience_description">
                        {@html experience.description.replace(/\n/g, '<br />')}
                      </div>
                    {/if}
                    {#if !!experience.video_link}
                      <div
                        class="exp-video-wrapper no_print"
                        id="experience_video_{i}" />
                    {/if}
                  </div>
                </div>
              {/each}
            </div>
          {/if}

          {#if !!categories}
            <div class="right-section categories">
              <h4 class="section-title">{work_fields_title}</h4>
              {#each categories as category}
                <div
                  class="category"
                  title={worked_amount_text.format(category.amount)}>
                  <span class="category_name">{category.name}</span>
                  <span class="category_count">{category.amount}</span>
                </div>
              {/each}
            </div>
          {/if}

          {#if !!feedbacks}
            <div class="right-section feedbacks">
              {#if feedbacks.length > 0}
                <h4 class="section-title">
                  {wp_tasks_title}
                  <div class="hexagon_rating">
                    <div class="background">
                      <span class="hex empty" />
                      <span class="hex empty" />
                      <span class="hex empty" />
                      <span class="hex empty" />
                      <span class="hex empty" />
                    </div>
                    <div class="foreground" style={format_rating_style(worker)}>
                      <span class="hex filled" />
                      <span class="hex filled" />
                      <span class="hex filled" />
                      <span class="hex filled" />
                      <span class="hex filled" />
                    </div>
                  </div>
                </h4>

                {#each feedbacks as feedback}
                  <div class="review-item">
                    <div class="review-reviewer">
                      <span class="orderer">{`${feedback.orderer_name}:`}</span>
                      <span class="order_title">{feedback.order_title}</span>
                    </div>
                    {#if !!feedback.message}
                      <div class="review-content">{feedback.message}</div>
                    {/if}
                  </div>
                {/each}

                <!--{#each feedbacks as order}-->
                <!--  <div class="review-item">-->
                <!--    <div class="review-reviewer">-->
                <!--      <span class="orderer">{`${order.orderer.last_name}:`}</span>-->
                <!--      <span class="order_title">{order.description}</span>-->
                <!--    </div>-->
                <!--    {#if !!order.feedback.from_orderer.message}-->
                <!--      <div class="review-content">{order.feedback.from_orderer.message}</div>-->
                <!--    {/if}-->
                <!--  </div>-->
                <!--{/each}-->
              {:else}
                <p
                  class="no-tasks hidden"
                  style="text-align: center;margin-top:10px; font-weight: 300;">
                  {no_tasks_message}
                </p>
              {/if}
            </div>
          {/if}

        </div>
      </div>
    </div>
  </div>
</UnauthenticatedLayout>

<style>
  h4 {
    font-family: 'Open Sans', sans-serif;
    font-weight: 500;
    line-height: 1.1;
    color: inherit;
    margin-bottom: 10px;
  }
</style>
